/**
 * Throttle + dedupe del reporte de errores del cliente.
 *
 * Evita inundar /api/errors/log (y los logs del servidor) cuando un mismo error se
 * repite muchas veces (re-render, polling que falla, varios listeners para un mismo
 * fallo). Aplica:
 *   - Cooldown por huella: el mismo error no se reporta más de 1 vez cada COOLDOWN_MS.
 *   - Tope global: como máximo MAX_PER_WINDOW reportes por ventana de WINDOW_MS.
 */
const COOLDOWN_MS = 5 * 60 * 1000;   // mismo error: máx. 1 vez cada 5 min
const WINDOW_MS = 60 * 1000;         // ventana global de 1 min
const MAX_PER_WINDOW = 8;            // máx. 8 reportes por minuto en total

const seen = new Map(); // fingerprint -> último ts reportado
let windowStart = Date.now();
let windowCount = 0;

function fingerprint({ type = "error", route = "", message = "" }) {
  const normMsg = String(message)
    .replace(/[0-9a-f]{8,}/gi, "*")  // ids/hex
    .replace(/\d+/g, "#")            // números
    .slice(0, 160);
  return `${type}|${route}|${normMsg}`.toLowerCase();
}

/** Decide si este error debe reportarse ahora (true) o silenciarse (false). */
export function shouldReportError(payload) {
  const now = Date.now();

  // Tope global por ventana.
  if (now - windowStart > WINDOW_MS) {
    windowStart = now;
    windowCount = 0;
  }
  if (windowCount >= MAX_PER_WINDOW) return false;

  // Cooldown por huella.
  const fp = fingerprint(payload);
  const last = seen.get(fp);
  if (last && now - last < COOLDOWN_MS) return false;

  seen.set(fp, now);
  windowCount += 1;

  // Limpieza para evitar crecimiento ilimitado del mapa.
  if (seen.size > 200) {
    const cutoff = now - COOLDOWN_MS;
    for (const [k, v] of seen) {
      if (v < cutoff) seen.delete(k);
    }
  }
  return true;
}
